<script type="text/ecmascript-6">
import { h, defineComponent, vShow, withDirectives, computed, resolveDirective } from 'vue'
import SpIcon from '@/components/common/SpIcon.vue'
import SpTooltip from '@/components/common/SpTooltip'
import SpPagenation from '@/components/common/SpPagenation'
import { isBoolean, isNum, isObject } from '@/utils'
import { off, on } from '@/utils/dom'
import SpScroll from '@/components/common/SpScroll'
import vEllipsis from '@/directives/ellipsis'
export default defineComponent({
  name: 'SpTableDIY',
  nameSpace: 'SpTableDIY',
  components: {
    SpIcon,
    SpTooltip,
    SpPagenation
  },

  directives: {
    vEllipsis
  },

  provide () {
    return {
      SpTable: computed(() => {
        return {
          name: 'SpTable',
          columns: this.columns,
          tagIndex: this.tagIndex,
          updateTagIndex: (key) => {
            this.tagIndex = key
          }
        }
      })
    }
  },

  inject: ['SpTablePageProvide'],

  props: {
    dataList: {
      type: [Array, Number],
      default: () => {
        return []
      }
    },

    currPage: {
      type: Number,
      default: 0
    },

    total: {
      type: Number,
      default: 0
    },

    pageSize: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: 'primary'
    },

    showArrow: Boolean,

    border: {
      type: String,
      default: 'border'
    },

    width: {
      type: [String, Number],
      default: '100%'
    },

    height: {
      type: [String, Number],
      default: 0
    },

    maxWidth: {
      type: [String, Number],
      default: 0
    },

    maxHeight: {
      type: [String, Number],
      default: 0
    },

    columnHeight: {
      type: [String, Number],
      default: ''
    },

    popHeaderStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },

    popDataStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },

    class: {
      type: [String, Array, Object],
      default: ''
    },

    haveHead: {
      type: Boolean,
      default: true
    },

    showExpand: {
      type: Function,
      default: () => true
    },

    hidePagination: {
      type: Boolean,
      default: false
    },

    destroyWhenHide: {
      type: Boolean,
      default: true
    },

    cusTagIndex: {
      type: [String, Array, Object],
      default: ''
    },

    rowClickExpend: {
      type: Boolean,
      default: true
    }
  },

  emits: ['update:currPage', 'change-page', 'afterExpand', 'rowClick', 'headerClick'],

  data () {
    return {
      columns: [],
      arrowDown: require('@/assets/spIcons/arrowDown.png'),
      tagIndex: ''
    }
  },

  computed: {
    $lp () {
      return function (name) {
        if (!name) {
          return name
        }
        return this.$t('table.' + name)
      }
    },

    headerClass () {
      const classes = []
      if (this.type === 'primary') {
        classes.push('sp-color-bg-3')
      }
      if (this.border === 'border') {
        classes.push('border')
      }
      return classes
    },

    dataClass () {
      const classes = []
      if (this.border === 'border') {
        classes.push('border')
      }
      return classes
    },

    getHeader () {
      if (!this.haveHead) return false
      const headChildren = []
      const renderHearder = (c, columnIndex, colspan, fixed) => {
        headChildren.push(h('td', {
          class: [...this.headerClass, fixed ? `fixed-column-${isBoolean(fixed) ? 'right' : fixed}` : '', c.label === 'Notes' ? 'pointer-header' : null],
          key: `table-header-${columnIndex}`,
          colspan: colspan,
          style: Object.assign(this.style(c.width, true), this.popHeaderStyle),
          onClick: (e) => { this.headerClick(c, columnIndex, e) }
        },
        h('div', { class: 'head-column flex-center', style: this.style(c.width, true) }, c.header ? c.header(h) : (this.$lp(c.label) || c.columnName))))
      }
      this.columns.forEach((c, columnIndex) => {
        if (c.render instanceof Array) {
          renderHearder(c, columnIndex, c.render.length, c[0]?.fixed)
        } else {
          renderHearder(c, columnIndex, 1, c.fixed)
        }
      })
      if (this.$slots.expand && this.showArrow) {
        headChildren.push(h('td', { width: '30px', class: ['arrow'] }))
      }
      return h('thead', { class: 'table-head' }, h('tr', null, headChildren))
    },

    getColumnsrender () {
      const children = []
      // const showDataList = this.dataList.slice(0, 50)
      this.dataList.forEach((d, index) => {
        const trChildren = []
        const renderDataColumn = (c, columnIndex, width, fixed, ellipsis, slot, render) => {
          trChildren.push(h('td', {
            class: [...this.dataClass, fixed ? `fixed-column-${isBoolean(fixed) ? 'right' : fixed}` : ''],
            key: `table-td-${index}-${columnIndex}-${JSON.stringify(d[c.columnName])}`,
            style: Object.assign(this.style(width), this.popDataStyle),
            onClick: (e) => { this.click(d, index, e) }
          },
          h('div', { class: [{ 'data-column': !slot }, 'flex-center default-column'], style: this.style(width) },
            !slot && ellipsis && width
              ? h(SpTooltip, { width: width - 13 }, render(h, d, index))
              : withDirectives(h('div', { class: ['flex-100', { ellipsis: ellipsis }] }, render(h, d, index)), [[vEllipsis]]))))
        }
        this.columns.forEach((c, columnIndex) => {
          if (typeof c.render === 'function') {
            renderDataColumn(c, columnIndex, c.width, c.fixed, c.ellipsis, c.slot, c.render)
          } else if (c.render instanceof Array) {
            c.render.forEach((r, index) => {
              renderDataColumn(c, columnIndex, c.width?.[index], c.fixed?.[index], c.ellipsis?.[index], c.slot?.[index], r)
            })
          }
        })
        // 渲染扩展列箭头
        if (this.$slots.expand && this.showArrow && this.showExpand(d)) {
          trChildren.push(h('td', { class: ['arrow pointer'], width: '30px', onClick: () => { this.expand(d, index) } },
            h('img', { class: ['arrow-init', { 'arrow-down': d.expand }], src: this.arrowDown })))
        }
        // 渲染行，key值需要唯一，直接取id或行数据字符串前十位
        children.push(h('tr', { key: `table-tr-${index}-${d.id || JSON.stringify(d).slice(0, 10)}` }, trChildren))
        // 渲染扩展列
        if (this.$slots.expand) {
          const data = isObject(d) ? d : { data: d }
          data.$index = index
          if (!this.destroyWhenHide) {
            children.push(withDirectives(h('tr', { key: `table-tr-expand-${index}-${d.id || JSON.stringify(d).slice(0, 10)}` }, h('td', {
              class: [...this.dataClass, 'expand data-column'],
              style: this.popDataStyle,
              colspan: this.getExpandCols()
            },
            this.$slots.expand(data))), [[vShow, d.expand]]))
          } else if (d.expand) {
            children.push(h('tr', { key: `table-tr-expand-${index}-${d.id || JSON.stringify(d).slice(0, 10)}` }, h('td', {
              class: [...this.dataClass, 'expand data-column'],
              style: this.popDataStyle,
              colspan: this.getExpandCols()
            },
            this.$slots.expand(data))))
          }
        }

        // 渲染扩展列1
        if (this.$slots.expand1) {
          const data = isObject(d) ? d : { data: d }
          data.$index = index
          if (!this.destroyWhenHide) {
            children.push(withDirectives(h('tr', { key: `table-tr-expand-${index}-${d.id || JSON.stringify(d).slice(0, 10)}` }, h('td', {
              class: [...this.dataClass, 'expand data-column'],
              style: this.popDataStyle,
              colspan: this.getExpandCols()
            },
            this.$slots.expand1(data))), [[vShow, d.expand1]]))
          } else if (d.expand1) {
            children.push(h('tr', { key: `table-tr-expand-${index}-${d.id || JSON.stringify(d).slice(0, 10)}` }, h('td', {
              class: [...this.dataClass, 'expand expand1 data-column'],
              style: this.popDataStyle,
              colspan: this.getExpandCols()
            },
            this.$slots.expand1(data))))
          }
        }
      })

      return children
    },

    SpTablePage () {
      return this.SpTablePageProvide?.value || {}
    }

  },

  watch: {
    dataList: {
      handler () {
        console.log(this.$refs)
        if (this.$refs?.scroll && this.$refs?.scroll.initScroll) {
          this.$refs.scroll.initScroll()
        }
      }
    },

    cusTagIndex: {
      handler () {
        this.tagIndex = this.cusTagIndex
      }
    }
  },

  created () {
    // if (!Array.isArray(this.dataList)) {
    //   this.dataList = new Array(parseFloat(this.dataList)).fill({})
    // }
    // console.log(this.SpTablePage)
  },

  mounted () {
    // on(this.$refs.table, 'mousedown', this.onMouseMove)
    this.$refs.scroll.initScroll()
  },
  //
  // beforeUnmount () {
  //   off(this.$refs.table, 'mousedown', this.onMouseMove)
  // },

  methods: {
    style (width, header) {
      if (Array.isArray(width)) {
        return width.reduce((pre, cur) => pre + cur)
      }
      return { width: width !== 0 ? width + 'px' : 'auto', height: header ? 'auto' : `${this.columnHeight}px` }
    },

    headerClick  (c, columnIndex, e) {
      this.$emit('headerClick', c, columnIndex, e)
    },

    getExpandCols () {
      let sum = 0
      this.columns.forEach(c => {
        if (typeof c.render === 'function') {
          sum++
        } else if (c.render instanceof Array) {
          sum += c.render.length
        }
      })
      return sum
    },

    expand (d, index) {
      d.expand = !d.expand
      d.expand1 = false
      if (d.expand) {
        this.$emit('afterExpand', d, index)
      }
    },

    expandOther (d, index) {
      d.expand1 = !d.expand1
      d.expand = false
      if (d.expand1) {
        this.$emit('afterExpand', d, index)
      }
    },

    click (d, index, e) {
      if (!this.showArrow) {
        if (this.rowClickExpend) {
          this.expand(d, index)
        }
      } else {
        this.$emit('rowClick', d, index)
      }
    },

    changeCurrPage (page) {
      this.$emit('update:currPage', page)
      this.$emit('change-page', page)
      if (this.SpTablePage.getMore) {
        this.SpTablePage.getMore(page)
      }
    }
  },

  render () {
    // console.log('bain')
    // console.log(this.dataList)
    return [h(SpScroll, {
      ref: 'scroll',
      enableMouseRightMove: 'x',
      class: ['SpTableDIY', ...Array.isArray(this.class) ? this.class : [this.class]],
      width: typeof this.width === 'number' ? this.width + 20 : this.width,
      height: this.height,
      maxWidth: this.maxWidth,
      maxHeight: this.maxHeight
    },
    [h('div', { class: 'hiddenc-column' }, this.$slots.default()),
      h('table', { class: 'table', border: 0, cellspacing: 0, cellpadding: 0, style: { width: '100%' } },
        [this.getHeader, this.getColumnsrender])
    ]), !this.hidePagination && (this.total || this.SpTablePage.total) > (this.pageSize || this.SpTablePage.pageSize) ? h(SpPagenation,
      {
        total: this.total || this.SpTablePage.total,
        pageSize: this.pageSize || this.SpTablePage.pageSize,
        currPage: this.currPage || this.SpTablePage.currPage,
        class: ['pagenation'],
        onChangeCurrpage: this.changeCurrPage
      }) : null]
  }
})
</script>

<style scoped lang="less">
.SpTableDIY{
  //width:auto;
  //overflow-x: auto;
  //overflow-y: auto;
  //word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
  .hiddenc-column{
    visibility: hidden;
    position: absolute;
    z-index: -100;
  }
  .table{
    width: auto;
    border-collapse: collapse;
    .border{
      border:1px solid #DBDBDB;
      //border:none;
      //
      //outline-color: #DBDBDB;
      //
      //outline-style:solid;
      //
      //outline-width:0.25px;
      //
      //border-top: 1px solid #DBDBDB;
    }
    .table-head{
      z-index: 10;
      position: sticky;
      top:-1px;
      .fixed-column-right{
        background: #D6E9F0;
        display: inline-block;
        margin-top: -1px;
        border-top: 1px #DBDBDB solid !important;
        //box-shadow: -3px 0px 3px 0px rgba(0,0,0,.1);
      }
      .pointer-header{
        .head-column{
          color: #3A909D;
          cursor: pointer;
        }
      }
    }
    .head-column{
      min-height: 60px;
      font-size: 18px;
      font-family: Arial;
      font-weight: bold;
      text-align: center;
      white-space: nowrap;
    }
    .default-column{
      font-size: 15px;
      font-family: Arial;
      font-weight: bold;
      vertical-align: middle;
      text-align: center;
      min-height: 60px;
      // padding:0 @gap/3;
      box-sizing: border-box;
      position: relative;
    }
    .data-column{
      padding: 0 24px;
    }
    .flex-center{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .fixed-column-right{
      position:sticky;
      right:0;
      background-color: white;
      display: inline-block;
      border-top: 0 !important;
      //box-shadow: -3px 0px 3px 0px rgba(0,0,0,.1);
    }
    .arrow{
      position:sticky;
      right:0;
      text-align: center;
      // border: 1px solid white;
       background-color: white;
    }
    .arrow-init{
      vertical-align: middle;

      transition-duration: .5s;
    }
    .arrow-down{
      transform: rotate(180deg);
      transition-duration: .5s;
    }
    .expand{
      //font-size: 0px;
      padding: 0;
    }
    .expand1 {
      font-size: 0;
    }
  }
  .pagenation{
    margin-top: @gap/3;
    margin-right: @gap;
  }
}
</style>
